<template>
  <div>
    <b-img
      class="mmp-img"
      fluid
      alt="Responsive image"
      :src="'../../../assets/MapManagementPlatform.png'"
    ></b-img>
    <div class="info-tooltip">
      <fa :icon="['fas', 'info-circle']" class="info-icon" />
      <span class="info-tooltip-text">
        DMP Map Management Platform
        <br />
        Version {{ this.versionReleaseInfo.version }}
        <br />
        Released {{ this.versionReleaseInfo.release_date }}
      </span>
    </div>
  </div>
</template>

<style scoped>
.info-icon {
  position: absolute;
  top: 10px;
  left: -5px;
}
.info-tooltip {
  position: relative;
  display: inline-block;
}
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  width: 200px;
  font-size: 15px;
  top: -55px;
  margin-left: 30px;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 200000;
}
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
}
.mmp-img {
  max-width: 180px;
  text-align: center;
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'MMP_AppLogo',
  data() {
    return {
      versionReleaseInfo: [],
    }
  },
  methods: {
    // This method is never used - there is no user data variable, no user prop, no function call
    //  There is this exact code declared and used in MapManagementPlatform.vue
    getReleaseVersion(user) {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/checkReleaseVersion',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {id: user.org}
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('checkReleaseVersion API Call Error: ' + content.errors)
            } else {
              this.versionReleaseInfo = content[0]
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    }
  },
}
</script>
